import React from "react";
import { withRouter } from 'react-router-dom';
  
 class Goback extends React.Component{
    componentDidMount(){
        this.props.history.goBack();    }
 render(){
     return(
         <>
         </>
     )
 }
    
   
   
}
 

export default withRouter(Goback);
 

 